var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGroceriesDefaultImage = function SvgGroceriesDefaultImage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#groceries-default-image_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEDEA",
    d: "M44.546 4.5C46.446 4.5 48 6.034 48 7.908v25.91c0 1.875-1.554 3.41-3.454 3.41h-3.09v3.135c0 1.875-1.555 3.41-3.455 3.41H3.454c-1.9 0-3.454-1.535-3.454-3.41V14.454c0-1.875 1.554-3.408 3.454-3.408h3.09V7.908C6.546 6.034 8.1 4.5 10 4.5zM3.454 13.773c-.367 0-.69.32-.69.681v25.91c0 .361.324.68.69.68h34.547c.366 0 .691-.319.691-.68v-25.91c0-.36-.325-.681-.691-.681zm32.474 15v9.545H5.526v-4.091l6.91-6.817 3.455 3.407L26.945 19.91zM9.673 16.5c2.288 0 4.144 1.834 4.144 4.092s-1.856 4.09-4.144 4.09-4.146-1.833-4.147-4.09c0-2.258 1.858-4.092 4.147-4.092M38 11.046c1.9 0 3.454 1.533 3.454 3.408V34.5h3.09c.366 0 .692-.32.692-.682V7.908c0-.36-.326-.68-.691-.68H9.999c-.367 0-.69.32-.69.68v3.138z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "groceries-default-image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGroceriesDefaultImage);
export default ForwardRef;